import React from 'react';
import { Link } from 'react-router-dom';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  href?: string;
  className?: string;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  href,
  className = '',
  onClick,
  type = 'button'
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-colors rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 shadow-md';
  const variantStyles = {
    primary: 'bg-black hover:bg-gray-800 text-white focus:ring-black',
    secondary: 'bg-gray-800 hover:bg-gray-900 text-white focus:ring-gray-800',
    outline: 'border-2 border-black text-black hover:bg-gray-100 focus:ring-black'
  };
  const sizeStyles = {
    sm: 'text-sm px-3 py-1.5',
    md: 'text-base px-5 py-2.5',
    lg: 'text-lg px-7 py-3.5 font-semibold'
  };
  const styles = `${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`;
  // Function to scroll to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  // Combined click handler
  const handleClick = (e: React.MouseEvent) => {
    scrollToTop();
    if (onClick) onClick();
  };
  if (href) {
    if (href.startsWith('http')) {
      return <a href={href} className={styles} target="_blank" rel="noopener noreferrer" onClick={scrollToTop} data-id="element-119">
          {children}
        </a>;
    }
    return <Link to={href} className={styles} onClick={scrollToTop} data-id="element-120">
        {children}
      </Link>;
  }
  return <button className={styles} onClick={handleClick} type={type} data-id="element-121">
      {children}
    </button>;
}